import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SubscriptionsContainer from './SubscriptionsContainer';
import UnregisteredPayments from './UnregisteredPaymentsContainer';

const SubscriptionsWrapper = () => {
  const items = [
    { title: 'Payments', component: SubscriptionsContainer },
    { title: 'Unregistered Payments', component: UnregisteredPayments },
  ];
  const [currentItem, setCurrentItem] = useState(items[0]);

  const handleItemClick = (selectedIndex) => {
    setCurrentItem(items[selectedIndex]);
  };

  return (
    <>
      <div className="px-3 md:mb-0">
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={items.map(item => item.title).indexOf(currentItem.title)}
            onChange={e => handleItemClick(e.target.value)}
          >
            {items.map((item, i) => (
              <option value={i} key={item.title}>{item.title}</option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div className="w-full py-2 ">
        <currentItem.component />
      </div>
    </>
  );
};

SubscriptionsWrapper.defaultProps = {
};

SubscriptionsWrapper.propTypes = {
};

export default SubscriptionsWrapper;
